import type { Action } from 'state/actions';
import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import * as batchActionTypes from 'state/batchForm/batchForm.actionTypes';
import * as dynamicActionTypes from 'state/dynamic/dynamicForm.actionTypes';
import { addOrReplaceKey, patchKey, removeKey, removeKeys } from 'state/utils/collection';

import type { PendingQuoteInfos, PendingQuoteInfosMap } from './pendings.model';

export function pendingsReducer(state: PendingQuoteInfosMap = {}, action: Action): PendingQuoteInfosMap {
  switch (action.type) {
    case 'QUOTE_REQUESTED':
    case 'STREAM_REQUESTED':
    case addonActionTypes.ADDON_QUOTE_REQUESTED:
      const { quoteRequestStartingTimeInMillis } = action;
      return addOrReplaceKey(state, action.tabId, <PendingQuoteInfos>{
        quoteRequestStartingTimeInMillis,
      });
    case dynamicActionTypes.DYNAMIC_BOOKING_REQUESTED:
      return addOrReplaceKey(state, action.tabId, <PendingQuoteInfos>{});
    case batchActionTypes.BATCH_QUOTE_REQUESTED: {
      const { quoteRequestStartingTimeInMillis } = action;
      return action.formIds.reduce(
        (result, formId) => addOrReplaceKey(result, formId, { quoteRequestStartingTimeInMillis }),
        state,
      );
    }

    case 'QUOTE_REMOVED':
    case 'STREAMING_QUOTE_ACKED':
    case 'QUOTE_ACKED':
    case dynamicActionTypes.DYNAMIC_BOOKING_ACKED:
    case addonActionTypes.ADDON_QUOTE_ACKED:
    case 'FORM_ENRICHMENT_RECEIVED':
      return removeKey(state, action.tabId);
    case batchActionTypes.BATCH_QUOTE_ACKED:
      return removeKeys(
        state,
        action.forms.map(form => form.negotiationId),
      );

    case batchActionTypes.BATCH_FORM_ENRICHMENT_RECEIVED:
      return removeKey(state, action.formId);

    case 'QUOTE_REQUEST_FAILED':
    case dynamicActionTypes.DYNAMIC_BOOKING_REQUEST_FAILED:
    case addonActionTypes.ADDON_QUOTE_REQUEST_FAILED:
      return patchKey(state, action.tabId, () => ({
        technicalError: action.technicalError,
      }));
    case 'QUOTES_REMOVED':
      return removeKeys(state, action.quoteIds);
    default:
      return state;
  }
}
